import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IOverlayLoaderStore } from '../../../../../../modules/common/OverlayLoader.store';
import { ImageScopeName } from '../../../../annotation/question.model';
import { AttributesList } from '../components/AttributesList';
import { IProjectDetailsToolsBl } from '../projectDetailsTools.bl';

export const AttributesListContainer = observer((): ReactElement => {
  const projectDetailsToolsBl = useInjection(IProjectDetailsToolsBl.$);
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);

  const handleOrderChangeAsync = async (questionId: string, index: number, isAttribute: boolean): Promise<void> => {
    await projectDetailsToolsBl.changeQuestionOrderAsync(questionId, index, isAttribute);
  };

  const { questions, annotationTypes } = projectDetailsToolsBl.store;

  return (
    <AttributesList
      questions={questions.filter((q) => !q.scopes.includes(ImageScopeName)).slice()}
      markingTools={annotationTypes}
      usedTools={annotationTypes.filter((t) => t.isUsed).map((t) => t.id.toUpperCase())}
      onOrderChange={handleOrderChangeAsync}
      isLoading={overlayLoaderStore.isSpinnerVisible('getProjectDetailsAnnotation')}
    />
  );
});
